export default "__VITE_ASSET__ZzB57Xj5__"